import { EConnectionCheckErrors, ETelematicsMessagesKeys } from "../types";

export const CHECK_CONNECTION_MESSAGES = {
  [EConnectionCheckErrors.BAD_CREDS]:
    ETelematicsMessagesKeys.CHECK_CONNECTION_ERROR_BAD_CREDS_SUBTITLE,
  [EConnectionCheckErrors.REQEST_ERROR]:
    ETelematicsMessagesKeys.CHECK_CONNECTION_ERROR_REQEST_ERROR_SUBTITLE,
};
